import { useTranslation } from "@next-platform/client-common-core";
import { useCallback, useMemo } from "react";
import { Stats } from "react-instantsearch";

import AppliedFiltersBarCharacter from "./FiltersV2/AppliedFiltersBarCharacter";

type SearchResultsSummaryProps = {
  isFiltersV2: boolean;
};

type SearchResultStats = {
  nbHits: number;
  processingTimeMS: number;
};

const SearchResultsSummary = ({ isFiltersV2 }: SearchResultsSummaryProps) => {
  const { t } = useTranslation();
  const renderResultCountText = useCallback(
    ({ nbHits, processingTimeMS }: SearchResultStats) => t("search:web.results.found", { count: nbHits, processingTimeMS }),
    [t],
  );
  const translations = useMemo(() => ({ rootElementText: renderResultCountText }), [renderResultCountText]);

  if (isFiltersV2) {
    return <AppliedFiltersBarCharacter />;
  }

  return <Stats className="text-label-sm font-regular" data-testid="search-stats" translations={translations} />;
};

export default SearchResultsSummary;
